// 国家列表
import { NativeModules } from 'react-native';
import { getCookie } from './cookie';
import { Platform } from 'react-native';
import { getAppProps, getNavigation } from '@/Navigation';
import { getPageProps, getUrlParam } from '@kibt/krn-utils';
import queryString from 'query-string';

export const language = (Platform.OS === 'web' ? navigator.language : NativeModules.KSLanguage?.getLanguage()).toLowerCase();
const country = language.split('-')[0];
console.log('language', language, country);

export const lang = (() => {
    switch (country) {
        case 'zh':
            return 'zh';
        case 'es':
            return 'es';
        case 'pt':
            return 'pt-BR';
        case 'id':
            return 'id';
        case 'in':
            return 'id';
        case 'en':
        default:
            return 'en';
    }
})();

// 过期情况怎么算
// 后续改成桥
export const isLogin = getCookie('token') || (getCookie('ud') && getCookie('ud') !== '0');

export const userId = getCookie('userId') || getCookie('ud');
export const deviceId = getCookie('did') || '';

// 激励动态配置 LocalStorage name
export enum incentiveKconfConfigName {
    name = 'INCENTIVE_KCONF_CONFIG_DATA',
}
export function getRequest() {
    let url = decodeURIComponent(window.location.search);
    const theRequest: Record<string, string> = {};
    if (url.indexOf('?') !== -1) {
        url = url.substr(1);
    }
    if (url) {
        const strs = url.split('&');
        for (let i = 0; i < strs.length; i++) {
            const srtArry = strs[i].split('=');
            const y = srtArry.shift() as string;
            theRequest[y] = decodeURIComponent(srtArry.join('='));
        }
    }
    return theRequest;
}

/**
 * @deprecated SPA上线后就不能用这个了，原因是SPA getQuery绑定了路由，绑定了组件树，大家使用useQuery吧
 */
export function getQuery(key: string): string {
    const nav = getNavigation();
    // SPA场景
    if (nav) {
        const paramFormRoute = nav?.getCurrentRoute()?.params?.[key];
        const paramFromApp = getAppProps()[key];
        if (key === 'itemId') {
            // console.log('itemId', paramFormRoute, paramFromApp);
        }
        return paramFormRoute || paramFromApp;
    }

    // MPA场景
    if (Platform.OS === 'web') {
        const url = new URL(window.location.href);
        const val = url.searchParams.get(key);
        if (key === 'env' && (!val || val === 'null')) {
            if (url.host.includes('staging.')) return 'staging';
            if (url.host.includes('prt.')) return 'prt';
        }
        return val;
    } else {
        return getUrlParam(key);
    }
}

/**
 * @deprecated SPA上线后就不能用这个了，原因是SPA getQuerys绑定了路由，绑定了组件树，大家使用useQuerys吧
 */
export function getQuerys(): Record<string, string | undefined> {
    if (Platform.OS === 'web') {
        const queryRes = queryString.parseUrl(window.location.href);
        return queryRes.query;
    } else {
        return getPageProps();
    }
}

export const kpn = getCookie('kpn') || 'KWAI';

export const isInBrowser = Platform.OS === 'web';

export const CountryNameList = {
    BRA: ['BRA', 'BR'],
    IDN: ['IDN', 'ID'],
};

// 获取国家
const getCountry = () => {
    const curCountry = (getCookie('countryInfo') || 'UNKNOWN').toUpperCase();
    const isIdn = CountryNameList.IDN.includes(curCountry);
    const isBra = CountryNameList.BRA.includes(curCountry);
    if (isIdn) {
        console.log('curCountry', curCountry);
        return CountryNameList.IDN[0];
    } else if (isBra) {
        return CountryNameList.BRA[0];
    }
    return null;
};

// 当前国家
// 不是印尼或者巴西，默认为巴西兜底
export const currentCountry = getCountry() || 'BRA';
// 不做兜底
export const currentCountryWithoutEars = getCountry();

export const getIsIdn = () => CountryNameList.IDN.includes(currentCountry);
export const getIsBra = () => CountryNameList.BRA.includes(currentCountry);

export const CountryCurrencyList = {
    BRA: 'R$',
    IDN: 'Rp',
};

export const webCurrency = CountryCurrencyList[currentCountry] || '';
export const RootTagMap = {
    OrderConfirm: 1,
};
